import { getV8DatabaseInstanceTargetCheckByInstanceId } from '@/api-client/metav8Over/queries/meta-database-instance-v8-controller/meta-database-instance-v8-controller';
import { TOTAL_DETAIL } from '@/common/stores/slide-detail.logic';
import { INSTANCE_ROLE } from '@/config/views/platform/database/instance/configDatabase.define';

interface DetailInfo {
  isCluster: boolean;
  dbType: string;
  subType: string;
  instanceId: string;
}

/*
  target-check API의 요청값별 응답 형태.
  연계에 사용할 instanceId 는 응답의 `clusterInstanceId || requestId` 로 결정한다.

  1) instanceId 로 요청
     → { clusterInstanceId: null, requestId: 요청한 instanceId }
       그 인스턴스로 그대로 연계.

  2) clusterId 로 요청
     → { clusterInstanceId: 클러스터에 속한 인스턴스의 instanceId, requestId: 요청한 clusterId }
       clusterInstanceId 로 클러스터 디테일에 연계.
     · 예외: 논리적 데이터베이스 클러스터링이면 → { clusterInstanceId: '', requestId: '' }
       연계할 인스턴스가 없어 클러스터 디테일 연계 불가.

  3) 삭제된 타겟
     → 오류 대신 { requestId: 요청한 Id, 그 외 필드는 null } 로 응답.
*/
const fetchDetailInfo = async (instanceOrClusterId: string): Promise<DetailInfo> => {
  const {
    data: { data },
  } = await getV8DatabaseInstanceTargetCheckByInstanceId(instanceOrClusterId);
  const { isCluster, dbType, subType, instanceRole, clusterInstanceId, requestId } = data || {};
  const instanceId = clusterInstanceId || requestId;

  return {
    isCluster: isCluster === 'true' || instanceRole === INSTANCE_ROLE.SINGLE_STORE_CLUSTER_INSTANCE,
    dbType: dbType || '',
    subType: subType || '',
    instanceId: instanceId || '',
  };
};

export const getDetailInfo = async (instanceOrClusterId: string) => {
  if (!instanceOrClusterId) {
    return { detailType: TOTAL_DETAIL.INSTANCE, dbType: '', instanceId: '' };
  }

  const detailInfo: DetailInfo = await fetchDetailInfo(instanceOrClusterId);

  const isCluster = detailInfo.isCluster;
  const isSharded = detailInfo.dbType === 'MONGODB' && detailInfo.subType === 'mongos';

  if (isCluster) {
    return {
      detailType: TOTAL_DETAIL.CLUSTER,
      dbType: detailInfo.dbType,
      instanceId: detailInfo.instanceId,
    };
  }
  if (isSharded) {
    return {
      detailType: TOTAL_DETAIL.SHARDED_CLUSTER,
      dbType: detailInfo.dbType,
      instanceId: detailInfo.instanceId,
    };
  }
  return {
    detailType: TOTAL_DETAIL.INSTANCE,
    dbType: detailInfo.dbType,
    instanceId: detailInfo.instanceId,
  };
};
